var _path, _path2, _path3, _circle, _path4, _rect, _rect2, _rect3, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 147,
    viewBox: "0 0 178 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8647 2.4905C33.1012 1.66732 33.9603 1.19173 34.7835 1.42825L144.196 32.8645C145.019 33.101 145.495 33.96 145.258 34.7832L123.197 111.567L113.822 144.196C113.586 145.019 112.727 145.495 111.903 145.258L2.49076 113.822C1.66758 113.585 1.19199 112.726 1.4285 111.903L32.8647 2.4905Z",
    fill: "#EBEDF9",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2617 15.7344H154.529V106.456L139.409 124.678L121.187 146.002H24.2617V15.7344Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2617 15.7344V15.2344H23.7617V15.7344H24.2617ZM154.529 15.7344H155.029V15.2344H154.529V15.7344ZM139.409 124.678L139.789 125.003L139.794 124.998L139.409 124.678ZM24.2617 146.002H23.7617V146.502H24.2617V146.002ZM154.529 106.456L154.914 106.776L155.029 106.637V106.456H154.529ZM121.187 146.002V146.502H121.417L121.567 146.327L121.187 146.002ZM121.187 106.456V105.956H120.687V106.456H121.187ZM24.2617 16.2344H154.529V15.2344H24.2617V16.2344ZM24.7617 146.002V15.7344H23.7617V146.002H24.7617ZM154.029 15.7344V106.456H155.029V15.7344H154.029ZM154.144 106.137L139.024 124.359L139.794 124.998L154.914 106.776L154.144 106.137ZM139.029 124.353L120.807 145.677L121.567 146.327L139.789 125.003L139.029 124.353ZM121.187 145.502H24.2617V146.502H121.187V145.502ZM121.687 146.002V106.456H120.687V146.002H121.687ZM121.187 106.956H154.529V105.956H121.187V106.956Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.8194,
    cy: 88.9444,
    r: 14.2803,
    stroke: "#EBEDF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.1 88.9444C107.1 92.2196 105.997 95.2372 104.143 97.6464C101.532 101.039 97.431 103.225 92.8194 103.225C84.9326 103.225 78.5391 96.8312 78.5391 88.9444C78.5391 81.0576 84.9326 74.6641 92.8194 74.6641",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.668,
    y: 98.5703,
    width: 11.7603,
    height: 31.9207,
    fill: "#9B65D1",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.9082,
    y: 112.012,
    width: 11.7603,
    height: 18.4804,
    fill: "#9B65D1",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7871,
    y: 76.7305,
    width: 11.7603,
    height: 53.7612,
    fill: "#9B65D1",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.506 42.543L114.982 63.0335H124.977L140.5 47.5292L135.506 42.543Z",
    fill: "#FAFAFF",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.501 20.6639L151.835 2.03621C150.456 0.654595 148.219 0.654595 146.836 2.03621C145.46 3.41028 145.46 5.64453 146.836 7.01859L147.721 7.90167L132.171 23.4158C129.367 20.6906 124.876 20.7096 122.1 23.4805C119.3 26.2743 119.3 30.8075 122.1 33.6013L139.003 50.4702C141.802 53.2642 146.343 53.2642 149.144 50.4702C151.946 47.6763 151.946 43.1434 149.144 40.3494L149.08 40.285L164.626 24.7705L165.507 25.6498C166.885 27.0276 169.125 27.0276 170.501 25.6498C171.883 24.2722 171.883 22.0417 170.501 20.6639Z",
    fill: "#EBEDF9",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.501 24.6639L156.835 6.03621C155.456 4.6546 153.219 4.6546 151.836 6.03621C150.46 7.41028 150.46 9.64453 151.836 11.0186L152.721 11.9017L137.171 27.4158C134.367 24.6906 129.876 24.7096 127.1 27.4805C124.3 30.2743 124.3 34.8075 127.1 37.6013L144.003 54.4702C146.802 57.2642 151.343 57.2642 154.144 54.4702C156.946 51.6763 156.946 47.1434 154.144 44.3494L154.08 44.285L169.626 28.7705L170.507 29.6498C171.885 31.0276 174.125 31.0276 175.501 29.6498C176.883 28.2722 176.883 26.0417 175.501 24.6639Z",
    fill: "#EBEDF9",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b72641f8f3021e4c4c816cf5ee87b363.svg";
export { ForwardRef as ReactComponent };